import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Question } from '../../App.styles';
import { Button, NavFooter } from '../../components';
import Result from '../../components/Result/Result';
import { ModelBrand } from '../../components/Result/Result.styles';
import {
  FlowStep,
  GlobalContext,
  StepperContext,
  updateFlowStep,
} from '../../contexts';
import { useTimeSpentMetric } from '../../hooks';
import { StepKey } from '../../types';
import { TestId, closeAmzModal } from '../../utils';
import GetNotified from './GetNotified';
import {
  Body,
  Header,
  HeaderIcon,
  HeaderTitle,
} from './NotCompatibleAmazon.styles';

const NotCompatibleAmazon: FunctionComponent = () => {
  const { stepperData } = React.useContext(StepperContext);
  const { dispatch } = React.useContext(GlobalContext);
  const { brand, model } = stepperData;
  const { t } = useTranslation('common');

  useTimeSpentMetric('notCompatible');

  return (
    <Result stepKey={StepKey.NotCompatible}>
      <div className="row h-100 flex-column" data-testid={TestId.NotCompatible}>
        <div className="flex-grow-1">
          <div className="mt-2 mt-md-4">
            <Header className="mb-3">
              <HeaderIcon />
              <HeaderTitle as={Question}>
                {t('results.notCompatible.amazon.title')}
              </HeaderTitle>
            </Header>
          </div>

          <Body>
            <span>{t('results.notCompatible.amazon.description')}</span>
            {brand && model ? (
              <>
                <span>:</span>
                <ModelBrand>
                  {brand}, {model.model_name}.
                </ModelBrand>
                <GetNotified brand={brand} model={model.model_name} />
              </>
            ) : (
              <span>.</span>
            )}
          </Body>
        </div>

        <NavFooter>
          <Button type="button" onClick={closeAmzModal}>
            {t('header.close')}
          </Button>
          <Button
            type="button"
            ghost
            onClick={() => {
              dispatch(
                updateFlowStep({ flowStep: FlowStep.compatibilityChecker })
              );
            }}
          >
            {t('header.back')}
          </Button>
        </NavFooter>
      </div>
    </Result>
  );
};

export default NotCompatibleAmazon;
